<div class="col" *ngIf="data!=null">
    <div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
        <ng-container *ngFor="let item of data; let i = index">
			<input type="radio" name="pcss3t"
				[(ngModel)]="tab" [value]="i" checked id="tab{{i}}">
			<label for="tab{{i}}">
				{{item.name}}
			</label>
        </ng-container>

		</div>
    <div class="table-responsive" *ngFor="let item of data; let i = index">
        <table class="table  table-sm position-relative" [hidden]="tab!==i">
            <thead class="position-sticky">
                <tr>
                <th rowspan="2" class="bg-secondary-subtle border-0">No.</th>
                <th *ngFor="let group of headerGroups"
                    [attr.colspan]="group.colspan"
                    class="text-center fw-bold bg-secondary-subtle border-0">
                    {{ group.label }}
                </th>
                </tr>

                <tr>
                <ng-container *ngFor="let group of headerGroups">
                    <th *ngFor="let col of group.columns" class="bg-secondary-subtle border-0">
                    {{ col.label }}
                    </th>
                </ng-container>
                </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of item.registros; let i = index">
                <td>{{ i + 1 }}</td>

                <ng-container *ngFor="let group of headerGroups">
                <td *ngFor="let col of group.columns" class="text-end">
                    <ng-container *ngIf="!col.empty">
                    <ng-container *ngIf="col.format; else normal">
                        {{ formatCell(row, col) | number:getNumberFormat(col) }}
                    </ng-container>

                    <ng-template #normal>
                        {{ formatCell(row, col) }}
                    </ng-template>
                    </ng-container>
                </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

    </div>

    <div class="table-responsive" *ngFor="let item of data; let i = index" [hidden]="tab!==i">
        <h6 class="mt-4">RESUMEN</h6>

        <table class="table table-bordered">
        <thead class="table-light">
            <tr>
            <th></th>
            <th>Precio Neto</th>
            <th>IVA Débito Fiscal</th>
            <th>Totales</th>
            </tr>
        </thead>
        <tbody>
            <tr>
            <td class="fw-bold">BIEN</td>
            <td class="text-end">{{ item.totalNeto | number:'1.2-2' }}</td>
            <td class="text-end">{{ item.totalIVA | number:'1.2-2' }}</td>
            <td class="text-end">{{ item.totalTotal | number:'1.2-2' }}</td>
            </tr>
            <tr>
            <td class="fw-bold">SERVICIO</td>
            <td class="text-end">{{ item.totalServices | number:'1.2-2' }}</td>
            <td class="text-end">0.00</td>
            <td class="text-end">0.00</td>
            </tr>
        </tbody>
        </table>

    </div>
</div>